<template>
  <b-row>
    <b-col md="6" class="mt-3">
      <div v-if="token">
        <p><strong>Token:</strong> <input class="mx-3" :value="token.key" size="50" readonly /></p>
        <p>{{ $t('created') | capitalize }} {{ tokenCreated }}</p>
        <div>
          <b-button variant="danger" class="my-5" @click="deleteToken" :disabled="loading">
            {{ $t('delete-auth-token') | capitalize }}
            <b-spinner v-if="loading" small type="grow" />
          </b-button>
        </div>
      </div>
      <div v-if="!token">
        <b-button variant="primary" @click="obtainToken" :disabled="loading">
          {{ $t('obtain-new-auth-token') | capitalize }}
          <b-spinner v-if="loading" small type="grow" />
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import config from '@/config';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import ToasterMixin from '@/mixins/Toaster';

const getUserAuthTokenUrl = () => new URL(
  config.ICOOL.API.USER_AUTH_TOKEN_PATH, config.ICOOL.BACKEND_HOST,
).href;

export default {
  name: 'UserAPIToken',
  data() {
    return {
      loading: false,
      token: null,
      breadcrumbs: [
        {
          text: this.$t('user-api-token-settings'),
        },
      ],
    };
  },
  computed: {
    tokenCreated() {
      return this.token ? moment(this.token.created).format('LLL') : null;
    },
  },
  methods: {
    async fetchToken() {
      try {
        const response = await axios.get(getUserAuthTokenUrl());
        this.token = response.data;
      } catch (err) {
        if (err.response.status !== 404) {
          console.log(err);
        }
      }
    },
    async deleteToken() {
      this.loading = true;
      try {
        const response = await axios.delete(getUserAuthTokenUrl());
        this.showToast(this.$t('user-settings'), this.$t('token-deleted'), 'success');
        this.token = null;
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    async obtainToken() {
      this.loading = true;
      try {
        const response = await axios.post(getUserAuthTokenUrl());
        this.token = response.data;
        this.showToast(this.$t('user-settings'), this.$t('token-obtained'), 'success');
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
  },
  mounted() {
    this.fetchToken();
  },
  mixins: [
    BreadcrumbsManager, ToasterMixin,
  ],
};
</script>

<style scoped></style>
